export default __webpack_public_path__ + "static/media/server-illustration.004793fc.svg";